import { render, staticRenderFns } from "./TransferenciaPremiosAsignacion.vue?vue&type=template&id=5f7f79c3&"
import script from "./TransferenciaPremiosAsignacion.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPremiosAsignacion.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPremiosAsignacion.vue?vue&type=style&index=0&id=5f7f79c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports